var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTel(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 49,
    viewBox: "0 0 50 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.1064 43.9C30.2516 43.9 35.1861 41.8561 38.8243 38.2179C42.4625 34.5797 44.5064 29.6452 44.5064 24.5C44.5064 19.3548 42.4625 14.4203 38.8243 10.7821C35.1861 7.14392 30.2516 5.1 25.1064 5.1C19.9612 5.1 15.0268 7.14392 11.3886 10.7821C7.75037 14.4203 5.70645 19.3548 5.70645 24.5C5.70645 29.6452 7.75037 34.5797 11.3886 38.2179C15.0268 41.8561 19.9612 43.9 25.1064 43.9ZM25.1064 48.75C11.7132 48.75 0.856445 37.8933 0.856445 24.5C0.856445 11.1067 11.7132 0.25 25.1064 0.25C38.4997 0.25 49.3564 11.1067 49.3564 24.5C49.3564 37.8933 38.4997 48.75 25.1064 48.75ZM17.5647 27.3372L11.507 25.4482C10.1975 25.048 10.1903 24.1459 11.8005 23.4985L35.403 14.3805C36.7731 13.8227 37.5491 14.5284 37.1053 16.2962L33.0871 35.2597C32.8058 36.6105 31.9934 36.933 30.8658 36.3097L24.6796 31.7313L21.7963 34.5152C21.5005 34.8014 21.2604 35.0463 20.8045 35.1069C20.351 35.17 19.9776 35.0342 19.7035 34.2825L17.5938 27.3203L17.5647 27.3397V27.3372Z",
    fill: "#1C1C27"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTel);
export default __webpack_public_path__ + "static/media/tel.8652011c073e9591d697de668042a03d.svg";
export { ForwardRef as ReactComponent };